import React from 'react';
import { Images, Link2, Wallet, ShieldCheck, Download, Smartphone } from 'lucide-react';
import { features, featuresTitle } from '../mock';

const iconMap = { Images, Link2, Wallet, ShieldCheck, Download, Smartphone };

export default function Features() {
  return (
    <section className="relative border-t border-[#1c1710]">
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-20 md:py-24">
        <h2 className="font-serif text-[34px] md:text-[44px] tracking-tight text-[#f2ecdf] mb-10 md:mb-14">
          {featuresTitle}
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((f, i) => {
            const Icon = iconMap[f.icon];
            return (
              <div key={i} className="card-glow rounded-xl p-6 md:p-7 transition-all duration-300">
                <div className="mb-5">
                  <Icon size={26} strokeWidth={1.6} className="feature-icon" />
                </div>
                <h3 className="font-serif text-[19px] md:text-[20px] text-[#f2ecdf] mb-2">
                  {f.title}
                </h3>
                <p className="text-[14px] leading-relaxed text-[#a89e87]">
                  {f.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
